import MyTypography from "@saleor/components/MyTypography";
import { SalesOrderSortListField } from "@saleor/createOrder/urls";
import { ListOfSaleOrderAndExcelQuery } from "@saleor/graphql";
import { makeStyles } from "@saleor/macaw-ui";
import { SortPage } from "@saleor/types";
import React from "react";

import TableData from "./Table";

export interface IOrderListTable extends SortPage<SalesOrderSortListField> {
  data: ListOfSaleOrderAndExcelQuery["listOfSaleOrderAndExcel"]["listOfSaleOrderSap"];
  settings: any;
  onUpdateListSettings: any;
  loading?: boolean;
  totalCount: number | null;
  isSaleOrderTracking?: boolean;
}

const useStyles = makeStyles(
  theme => ({
    root: {
      overflowX: "auto",
      width: "100%",
      border: `1px solid ${theme.palette.grey[300]}`,
      borderBottom: 0,
      borderRadius: "2px",
      marginBottom: 32,
      "& .MuiTable-root": {
        borderCollapse: "collapse"
      },
      "& .MuiTableCell-head": {
        border: `1px solid ${theme.palette.grey[300]}`,
        padding: "0 12px",
        minWidth: 160,

        "& *": {
          color: `${theme.palette.grey[900]} !important`
        }
      },
      "& .MuiTableCell-body": {
        border: `1px solid ${theme.palette.grey[300]}`,
        minWidth: 160,
        padding: "0 12px"
      },

      "&::-webkit-scrollbar": {
        height: "14px",
        background: "#FFFFFF",
        border: "1px solid #E0E0E0",
        borderLeft: 0,
        borderRight: 0
      },
      "&::-webkit-scrollbar-track": {
        borderRadius: 10
      },
      "&::-webkit-scrollbar-thumb": {
        background: "#CCCCCC",
        borderRadius: 6,
        border: "4px solid transparent",
        backgroundClip: "padding-box",
        height: "6px"
      },
      "& .MuiTableCell-head * ": {
        color: "#222222 !important"
      }
    },
    tableFooter: {
      background: "#DAF7FB",
      padding: "9px 12px",

      "& .MuiTableRow-root": {
        background: "#DAF7FB"
      },
      "& .MuiTableCell-footer": {
        border: `1px solid #DAF7FB`,
        padding: "0 12px"
      }
    },
    subColumn: {
      minWidth: 80
    },
    infoDark: {
      color: theme.palette.info.dark
    },
    cursorPointer: {
      cursor: "pointer"
    },
    rowOverDue: {
      background: `${theme.palette.scgPrimary.hover} !important`
    },
    title: {
      marginBottom: 24
    },
    flex: { display: "flex", alignItems: "center" },
    firstChild: {
      paddingLeft: 32
    },
    printBtn: {
      padding: "4px 15px",
      borderRadius: "4px",
      background: "#FFFFFF"
    },
    customCell: {
      height: "12px",
      padding: "0.8rem 1.2rem !important"
    },
    noBorder: {
      border: "0 !important"
    },
    thDelivery: {
      background: "#E6F6F8 !important"
    },
    delivery: {
      fontFamily: "ScgFont, sans-serif",
      fontWeight: 400,
      fontSize: "1.4rem",
      lineHeight: "20px",
      display: "flex",
      alignItems: "center"
    },
    borderRight: {
      borderRight: `1px solid ${theme.palette.grey[300]} !important`
    },
    infoFilled: {
      marginLeft: 5
    },
    tooltip: {
      "& .MuiTypography-root": {
        color: "#FFF"
      },
      borderRadius: 4,
      background: theme.palette.grey[600],
      padding: "4px 8px"
    },
    cellHeader: {
      color: theme.palette.grey[600]
    }
  }),
  { name: "OrderListTable1" }
);

const OrderListTable: React.FC<IOrderListTable> = ({
  data,
  totalCount,
  sort,
  onSort,
  isSaleOrderTracking
}) => {
  const classes = useStyles();

  return (
    <>
      {data.length ? (
        <MyTypography className={classes.title} variant="h7">
          รายการที่เกี่ยวข้อง ({totalCount})
        </MyTypography>
      ) : null}
      {data.map((soldTo, index) => (
        <TableData
          soldTo={soldTo}
          index={index}
          key={`${soldTo.soldTo} - ${soldTo.soldToName1}`}
          sort={sort}
          onSort={onSort}
          isSaleOrderTracking={isSaleOrderTracking}
        />
      ))}
    </>
  );
};

export default OrderListTable;
